// ═══════════════════════════════════════════════════════════════════════════
// guardia/config.js — Módulo /guardia: la pantalla única del Loop V2 (T0 PR-6)
// ═══════════════════════════════════════════════════════════════════════════
// Embrionaria a propósito (diseño §9): firma de Puerta Cero + estado del
// organismo + repaso de archivo. Reusa el permiso-módulo `debugging` — NO crea
// permiso nuevo (lente architect §13): quien autoriza informes en /debugging
// es exactamente quien firma acá. La vista por rol (reportador → su cola UAT)
// y la PWA instalable llegan con T3.
import { lazy } from 'react'

export default {
  id: 'guardia',
  nombre: 'La Guardia',
  descripcion: 'Panel del organismo de auto-mantenimiento: firma de informes (Puerta Cero), interruptor, markers de la guardia nocturna, dead-man y repaso de archivo.',
  icono: 'moon',
  tipo: 'admin',
  version: '1.0.0',
  milbrandsInterno: true,
  permisoModulos: ['debugging'],
  routes: [
    { path: 'guardia', component: lazy(() => import('./pages/GuardiaPage')) },
  ],
  menuItems: [],
  features: ['loop-debugging-v2'],
}
